"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftModalSection = void 0;
const ui_1 = require("@app/component/ui");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const shift_context_1 = require("../shift-context");
const use_available_shift_sections_1 = require("../use-available-shift-sections");
const ShiftModalSection = ({ id, children, headerContent, cleanup, sectionNameSuffix, }) => {
    const sections = (0, use_available_shift_sections_1.useAvailableShiftSections)();
    const { toggledSections, addSectionDisabledListener, removeSectionDisabledListener, } = (0, shift_context_1.useShift)();
    // sections have to be indexed in order in which they are defined in sidebar
    // because of that we have to map toggled ids into their {sections and defined indexes} and sort based on indexes
    const sortedToggledSections = toggledSections
        .map((secId) => ({
        index: sections.findIndex((sec) => sec.id === secId),
        section: sections.find((sec) => sec.id === secId),
    }))
        .filter((s) => (0, util_1.isDefined)(s.section))
        .filter((sec) => sec.section.id !== 'automatic-pause')
        .sort((a, b) => a.index - b.index);
    react_1.default.useEffect(() => {
        if ((0, util_1.isUndefined)(cleanup))
            return;
        addSectionDisabledListener(id, cleanup);
        return () => {
            removeSectionDisabledListener(cleanup);
        };
    }, [addSectionDisabledListener, cleanup, id, removeSectionDisabledListener]);
    if (!toggledSections.includes(id)) {
        return null;
    }
    const sectionIndex = sortedToggledSections.findIndex((sec) => sec.section.id === id) + 1;
    const section = sortedToggledSections.find((sec) => sec.section.id === id)?.section;
    if ((0, util_1.isUndefined)(section)) {
        throw new Error('section cannot be undefined');
    }
    return (react_1.default.createElement("div", { style: { width: '100%', height: '100%', display: 'flex', flexFlow: 'column' } },
        react_1.default.createElement("div", { style: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            } },
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'start',
                    marginBottom: '0.725rem',
                } },
                react_1.default.createElement("div", { style: {
                        width: '0.8rem',
                        height: '0.8rem',
                        borderRadius: '100%',
                        backgroundColor: '#0045ff',
                        fontSize: '0.45rem',
                        fontWeight: 'bold',
                        fontFamily: 'monospace',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        paddingLeft: 1,
                    } }, sectionIndex),
                react_1.default.createElement(ui_1.Text, { weight: 'bold', type: 'body-large' },
                    section.name,
                    ":",
                    sectionNameSuffix ? (react_1.default.createElement(ui_1.Text, { weight: 'medium', type: 'body-large', style: {
                            marginLeft: '6px',
                        } }, sectionNameSuffix)) : (false))),
            headerContent),
        children));
};
exports.ShiftModalSection = ShiftModalSection;
